module.exports = __webpack_public_path__ + "img/client-logo-4.c6613871.png";